import { IApplicationState } from '../../types/redux';

export const selectIsModalOpen = (state: IApplicationState) => state.print.isModalOpen;
